import { JsonClassDiscriminator3irfencugy52m as JsonClassDiscriminator } from '../JsonAnnotations.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  ENUMlmq49cvwy4ow as ENUM,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance1n14r8fdmxtk7 as ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance } from '../JsonConfiguration.mjs';
import { JsonEncodingException3vzv9k0f9l05u as JsonEncodingException } from '../JsonExceptions.mjs';
import { getJsonEncodedNames32epqb27gispq as getJsonEncodedNames } from './JsonNamesMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function classDiscriminator(_this__u8e3s4, json) {
  var _iterator__ex2g4s = _this__u8e3s4.a1q().p1();
  while (_iterator__ex2g4s.q1()) {
    var annotation = _iterator__ex2g4s.r1();
    if (annotation instanceof JsonClassDiscriminator())
      return annotation.v2u_1;
  }
  return json.z2n_1.w2p_1;
}
function subtypeNotRegisteredMessageJson(subClassName, baseClass) {
  var scope = "in the polymorphic scope of '" + baseClass.j1() + "'";
  var tmp;
  if (subClassName == null) {
    tmp = to('Class discriminator was missing and no default serializers were registered ' + scope, null);
  } else {
    tmp = to("Serializer for subclass '" + subClassName + "' is not found " + scope, "Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n" + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.j1() + "' has to be sealed and '@Serializable'."));
  }
  return tmp;
}
function access$checkEncodingConflicts$tJsonPolymorphicHelpersKt($receiver, serializer, actualSerializer, classDiscriminator) {
  return checkEncodingConflicts($receiver, serializer, actualSerializer, classDiscriminator);
}
function checkKind(kind) {
  if (kind instanceof ENUM()) {
    // Inline function 'kotlin.error' call
    var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException().o(toString(message));
  }
  if (kind instanceof PrimitiveKind()) {
    // Inline function 'kotlin.error' call
    var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException().o(toString(message_0));
  }
  if (kind instanceof PolymorphicKind()) {
    // Inline function 'kotlin.error' call
    var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
    throw IllegalStateException().o(toString(message_1));
  }
}
function checkEncodingConflicts(_this__u8e3s4, serializer, actualSerializer, classDiscriminator) {
  if (getJsonEncodedNames(actualSerializer.b1n(), _this__u8e3s4).t2(classDiscriminator)) {
    var baseName = serializer.b1n().e1o();
    var actualName = actualSerializer.b1n().e1o();
    var text = _this__u8e3s4.z2n_1.d2q_1.equals(ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance()) && baseName === actualName ? 'in ALL_JSON_OBJECTS class discriminator mode' : "as base class '" + baseName + "'";
    var tmp0_shortMessage = "Class '" + actualName + "' cannot be serialized " + text + ' because' + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'.");
    var tmp1_hint = 'You can either change class discriminator in JsonConfiguration, or rename property with @SerialName annotation.';
    throw JsonEncodingException().u2s(tmp0_shortMessage, actualName, tmp1_hint);
  }
}
//region block: exports
export {
  access$checkEncodingConflicts$tJsonPolymorphicHelpersKt as access$checkEncodingConflicts$tJsonPolymorphicHelpersKtlxbuf8m1156u,
  checkKind as checkKind2e7hdnuk9c0tp,
  classDiscriminator as classDiscriminator9fd3hvqsgfqq,
  subtypeNotRegisteredMessageJson as subtypeNotRegisteredMessageJson3mtuvvd9idjxz,
};
//endregion

//# sourceMappingURL=JsonPolymorphicHelpers.mjs.map
